import React, { useId } from 'react';
import FilterChip from './FilterChip';
import { isFilterEmpty } from './registry';

/** Removable chips for the active filters, above the table, plus "Clear all". */
const ActiveFiltersStrip = ({ fields, values, onRemove, onClearAll, onEdit }) => {
    const labelId = useId();
    const active = fields.filter((f) => !isFilterEmpty(f, values[f.key]));
    if (active.length === 0) return null;
    return (
        <div className="flex flex-wrap items-center gap-2 border-b border-slate-200 bg-white px-3 py-2">
            <span className="text-sm text-slate-500" id={labelId}>
                Filtered by
            </span>
            <ul className="flex min-w-0 flex-wrap items-center gap-2" aria-labelledby={labelId}>
                {active.map((f) => (
                    <li key={f.key} className="min-w-0 max-w-full">
                        <FilterChip
                            field={f}
                            value={values[f.key]}
                            onEdit={() => onEdit?.(f.key)}
                            onRemove={() => onRemove(f.key)}
                        />
                    </li>
                ))}
            </ul>
            <button
                type="button"
                onClick={onClearAll}
                className="rounded px-1 text-sm font-medium text-slate-600 underline-offset-2 outline-none hover:text-slate-900 hover:underline focus-visible:ring-2 focus-visible:ring-primary-300"
            >
                Clear all
            </button>
        </div>
    );
};

export default ActiveFiltersStrip;
